export default {"src":"/_next/static/media/url.fc2d22da.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};